// i18n.js
import { createI18n } from 'vue-i18n'

const messages = {
  en: {
    message: {
      about: 'About',
      autobats: 'MT Solution',
      autobats_subtitle: 'Focal mechanisms based on the AutoBATS inversion',
      aboutBATS: 'About BATS',
      aboutBATS_subtitle: 'Broadband Array in Taiwan for Seismology',
      about_BATS: 'About BATS',
      all: 'All',
      azimuth: 'Azimuth',
      amplitude: 'Amplitude',
      autoBATS_CMT: 'AutoBATS MT',
      address: 'Address',
      account: 'Account',
      agree: 'agree',
      BATS_station: 'BATS STATION',
      BATS: 'Broadband Array in Taiwan for Seismology',
      BATS_features: 'BATS FEATURES',
      BATS_Waveforms: 'BATS Waveforms',
      BATS_lowercase: 'Broadband Array in Taiwan for Seismology',
      // BATS_lowercase_br:'Broadband Array <span class="text-lowercase">in</span> Taiwan<br><span class="text-lowercase">for</span> Seismology',

      color: 'Color',
      cluster: 'Cluster',
      channel: 'Channel',
      constant: 'Constant',
      continuous_wd: 'Continuous Waveform Data',
      continuous_wd_dir: 'Note: time interval length for single station must be less than 90 days.',
      create_account: 'Create Account',
      citation: 'Citation',
      data_management: 'Data Management',
      data_request: 'Data request',
      depth: "Depth",
      data: 'Data',
      data_subtitle: 'High quality waveforms for scientific researches',
      dataProducts: 'Data Products',
      dataProducts_subtitle: 'Research outcome with BATS data',
      data_quality: 'Data Quality Browser',
      data_availability: 'Data Availability',
      data_source1:'Source: CWA',
      data_source2:'Source: CWA, USGS',
      download: 'Download',
      data_visualization: 'Data Visualization',
      disagree: 'disagree',
      dataProducts_title_01: 'AutoBATS Moment Tensor Solution Database',
      dataProducts_title_02: 'Taiwan Crustal Model',
      dataProducts_title_03: 'Realtime Moment Tensor Monitoring System (RMT)',
      dataProducts_subtitle_01: '',
      dataProducts_subtitle_02: '(receiver function based)',
      dataProducts_subtitle_03: '',
      end_date: 'End Date',
      end_date_: 'End_Date',
      event: 'Event(UTC)',
      elevation: 'Elevation',
      end_time: 'End Time(UTC)',
      end_time_: 'End Time',
      // email:'Email address',
      email: 'Email',
      forget_password: "Forgot Password",
      forget_password_p1: "Please insert your Email Address, we will send a mail to you to change password.",
      forget_password_2: "Reset Password",
      greater_BATS: 'Greater BATS',
      grid_line: 'Grid Line',
      google_scholar: 'Google Scholar',
      group_photos: 'Group photos',
      home: 'Home',
      historic: 'Historic',
      history: 'History',
      highlights: 'Highlights',
      help: 'Help',
      help_subtitle: 'BATS website user manual',
      instrument_info: 'Instrument Info',
      download_instrument_resp: 'Download Instrument Response',
      instrumentation: 'Instrumentation',
      ies: 'Institute of Earth Sciences, Academia Sinica',
      instrument_response: 'Instrument Response',
      links: 'Links',
      link: 'Link',
      links_subtitle: 'Where you might want to go further',
      latitude: 'Latitude',
      longitude: 'Longitude',
      location: 'Location',
      label: 'Label',
      login: 'Login',
      logout: 'Logout',
      login_error: 'Please log in first',
      link_subtitle_01: 'Taiwan Seismological & Geophysical Data Management System',
      link_subtitle_02: 'Taiwan Earthquake Research Data Center',
      link_subtitle_03: 'Taiwan Earthquake Scientific Information System',
      link_subtitle_04: 'Seismic Array of NCREE in Taiwan',
      link_subtitle_05: 'P-Alert Strong Motion Network',
      link_subtitle_06: 'Realtime Moment Tensor Monitoring System',
      link_subtitle_07: 'IES Data Management Center',
      link_subtitle_08: 'Taiwan Active Faults',
      link_subtitle_09: 'Realtime Moment Tensor Monitoring System (RMT)',
      login_success: 'Login Success',
      login_success_text: 'The system will automatically log out in one hour',
      login_success_text_2: 'Please log in to your account',
      login_failed: 'Login Failed',
      login_expired: 'Link expired',
      login_expired_text: 'Please re-apply for password reset',
      // login_errortext_check: 'Please check your account and password.',
      // login_errortext_verified: 'This account is not registered or verified',
      // login_errortext_wrong: 'Wrong password',
      login_errortext_check: 'Please check your account and password',
      login_errortext_verified: 'Please check your account and password',
      login_errortext_wrong: 'Please check your account and password',
      login_errortext_code: 'Verification code error',
      login_forgot_success: 'Success',
      login_forgot_success_text: 'Please go to your Email to complete the application process',
      login_forgot_failed: 'Failed',
      login_forgot_failed_text: 'Email does not exist',
      login_forgot_server_error: 'Server Error',
      login_forgot_server_error_text: 'A server error occurred. Please try again later.',
      login_forgot_failed_other: 'Request Failed',
      login_forgot_failed_other_text: 'The request could not be completed.',
      login_aut_failed: 'Authentication failed',
      login_reset_success: 'Success',
      login_reset_success_text: 'Please log in again with your new password',
      login_reset_failed: 'Failed',
      login_reset_failed_text: 'Setting failed',
      login_check_failed_text: 'Please check your password',
      login_reset_error: 'Please make sure the password field is filled in',
      login_register_success: 'Successful registration',
      login_register_s_text: 'Please go to your  <strong>Email</strong>  to receive the  <strong>verification email</strong>',
      login_register_failed: 'Registration failed',
      login_register_f_text: 'The Email or account already exists',
      login_register_error: 'Please make sure the Email and Password fields are filled in',
      login_register_server_error: 'Server Error',
      login_register_server_error_text: 'A server error occurred. Please try again later.',
      login_register_input_failed: 'Invalid input',
      login_register_input_failed_text: 'Please check all the input again.',
      login_register_failed_other: 'Request Failed',
      login_register_failed_other_text: 'The request could not be completed.',
      login_token_expired_1: 'Link is broken',
      login_token_expired_2: 'Please re-register',
      more: 'More',
      more_information: 'More Information',
      map_lock: 'Map Lock',
      min: 'min',
      max: 'MAX',
      ml: 'ML',
      multi_station_wd: 'Multi-Station Waveform Data',
      multi_station_wd_dir: 'Note: maximum time window must be less than 1 day (86400 s)',
      multi_event_wd: 'Multi-Event Waveform Data',
      multi_event_dir: 'Note: maximum number of event : 100',
      member_data: 'Personal Information',
      more_result: 'More scientific results',
      more_data: ' More data and information about Taiwan',
      name: 'Name',
      name_full: 'Name',
      affiliation: 'Affiliation',
      affiliation_note: 'Max 100 chars, only letters/numbers/Chinese/space plus "," and "_".',
      affiliation_note_popup: 'Affiliation invalid.',
      network: 'Network',
      no_data: 'No data',
      no_data_text: 'Please select another time period',
      online: 'Online',
      output: 'Output Format',
      our_team: 'Our Team',
      origin: 'origin(UTC)',
      people: 'People',
      people_subtitle: 'Work teams on science and technology',
      password: 'Password',
      password_new: 'New Password',
      password_check: 'Check Password',
      password_error: 'Password should include at least 1 upper and lower case letter, digit, and special character, and minimum length is 12.',
      password_check_error: 'Does not match password',
      position: 'position',
      PI: 'PI',
      read_more: 'More',
      recorder: 'Recorder',
      register: 'Register',
      required: 'Required',
      station: 'Station',
      station_subtitle: 'Broadband and strong motion records',
      start_date: 'Start Date',
      start_date_: 'Start_Date',
      setting: 'Setting',
      size: 'Size',
      station_list: 'Station List',
      search: 'Search',
      sensor: 'Sensor',
      start_time: 'Start Time(UTC)',
      submit: 'Submit',
      significant_E: 'Significant Earthquake Data',
      say_hello: "Say Hello",
      second: 'second',
      sign_up: 'Sign up',
      staff: 'Staff',
      select_format: 'Select format',
      select_network: 'Select network',
      select_station: 'Select station',
      select_location: 'Select location',
      select_channel: 'Select channel',
      select_start_time: 'yyyy-MM-dd HH:mm:ss',
      select_start_time_YMD: 'yyyy-MM-dd',
      select_end_time: 'yyyy-MM-dd HH:mm:ss',
      select_end_time_YMD: 'yyyy-MM-dd',
      select_label: 'Input label (Optional, limited to 30 characters)',
      travel_time_plot: 'Travel Time Diagram Plot',
      time_windows: 'Time Windows',
      to: 'to',
      title_station: 'Search station',
      title_lat_min: 'Search minimum latitude',
      title_lat_max: 'Search maximum latitude',
      title_lat: 'Search latitude',
      title_lon_min: 'Search minimum longitude',
      title_lon_max: 'Search maximum longitude',
      title_lon: 'Search longitude',
      title_start_min: 'Search start date minimum',
      title_start_max: 'Search start date maximum',
      title_start: 'Search start date',
      title_end_min: 'Search end date minimum',
      title_end_max: 'Search end date maximum',
      title_end: 'Search end date',
      DataSince: 'Data Since 2022.01.01',
      title_event: 'Search origin',
      title_ML_min: 'Search minimum ML',
      title_ML_max: 'Search maximum ML',
      title_depth_min: 'Search minimum depth',
      title_depth_max: 'Search maximum depth',
      apply_filter: 'Apply Filter',
      url_hide: 'Hide URL',
      url_show: 'Show URL',
      waveform: 'Waveform',
      wd_error_label_STET: 'Start time must be earlier than end time.',
      wd_error_label_2H: 'The start time and end time cannot exceed 2 hours.',
      wd_error_label_90D: 'The start time and end time cannot exceed 90 days.',
      wd_error_label_starttimeNull: 'Please select a start time.',
      wd_error_label_endtimeNull: 'Please select a end time.',
      wd_error_label_station: 'Please select at least one station.',
      wd_error_label_location: 'Please select at least one location.',
      wd_error_label_channel: 'Please select at least one channel.',
      wd_error_label_timewindows: 'Please select time windows.',
      wd_error_label_timeUTC: 'Please select a time(UTC).',
      wd_error_label_timeUTC_100: 'Cannot exceed 100 events',
      wd_error_label_timeUTC_format: 'Invalid date format',
      wd_error_label_timeUTC_data: 'Invalid date',
      wd_error_label_network: 'Please select a network.',
      wd_error_label_output: 'Please select a format.',
      web_data_services: 'Web Data Services',
      year: 'Year',
      //phase
      About_1_P1: 'Broadband Array in Taiwan for Seismology (BATS)',
      About_1_P2: 'In mid-1992, along with several domestic and foreign institutions, began to prepare a prospectus for establishing a broadband seismic network in the Taiwan region, which later named "Broadband Array in Taiwan for Seismology (BATS)". ',
      About_1_P3: 'The network, is initially designed with 15 permanent stations located on Taiwan and the surrounding islands, covering an area of approximately 350 km by 400 km.',
      About_1_P4: 'Currently the number of permanent broadband stations operated by IES is 36, including 2 located in the South China Sea with satellite transmission.',
      About_2_P1: 'Instrumentation',
      About_2_P2: 'The BATS instrumentation is designed to cover a variety of research demands.',
      About_2_P3: 'All permanent stations are equipped with state-of-the-art very-broadband and strong-motion sensors and 24/26-bits digital recorders.',
      About_2_P4: 'Data streams with high sampling rates (100 samples per s) were recorded in triggering mode before Q330 logger was used. After 2002, we gradually upgrade the dataloggers to gain the ability to continuously record ground motion at high sample rates.',
      About_2_P5: 'All stations are capable of internet connection for immediate retrieval of real-time data.',
      About_3_P1: 'Data Management',
      About_3_P2: 'Empowering seismological researches with reliable data for better understanding of the Earth',
      About_3_P3: 'We fully take advantage of various software platforms to operate the BATS data acquisition in the data center from the beginning. Preliminary data quality control is performed at IES.',
      About_3_P4: 'Afterwards, the data are distributed to the public through the web-based data service at the official BATS website.',
      About_3_P5: 'We have setup the IES Data Management Center (IESDMC) which is taking care of the routine network operation, data processing, quality control, and data distribution etc. Source inversion (AutoBATS solution) for significant earthquakes has been automated in near real-time.',
      AutoBATS_1: 'AUTOBATS',
      AutoBATS_2: 'The Automated Source Inversion: AutoBATS',
      AutoBATS_3: 'Upon receiving the CWA rapid alert, the automated source inversion system (AutoBATS) initiates the derivation of the moment tensor solution by inverting the extracted high-quality BATS waveform data. The resulting AutoBATS focal mechanisms are accessible through the online database.',
      Footer_1_P1: 'Rm7005, RCEC Building',
      Footer_1_P2: '128, Academy Road Section 2 Nankang 115',
      Footer_1_P3: 'Taipei, Taiwan',
      Footer_4_P1: 'Need AutoBATS Solution?',
      Footer_4_P2: 'Get verified AutoBATS Moment Tensor Solution by Subscribe Our Notification',
      Footer_4_P3: 'Subscribe AutoBATS Report',
      Footer_policy: 'Terms of Use, Information Security, and Privacy Policy',
      Home_1_P1: 'Backbone broadband seismic network in the Taiwan region',
      Home_1_P2: 'BATS is equipped with state-of-the-art seismometers and infrasound devices and operated by the Institute of Earth Sciences (IES), Academia Sinica, Taiwan since 1996.',
      Home_1_P3: 'We provide high quality waveform data and moment tensor solutions for better understanding of earthquake source physics and regional seismotectonics.',
      Home_2_P1: 'We Provide Seismic Waveform Data, MT Solutions and Instrumentation Service',
      Home_2_P2: 'Online waveform viewing, search and download',
      Home_2_P3: 'Moment tensor solutions based on the BATS waveform inversion',
      Home_2_P4: 'To trace the academic contribution of BATS, here are the search results from Google Scholar.',
      Home_3_P1: 'Modern BATS Web Services',
      Home_3_P2: 'The BATS Data Center embraces an open data policy and employs new techniques to develop efficient web services, making data request and visualization easier.',
      Home_3_P3: 'FAIR open data policy',
      Home_3_P4: 'Interactive waveform viewing',
      Home_3_P5: 'Google Scholar',
      Privacy_0: 'Privacy Policy',
      Privacy_1_P1: 'What personal information do we collect from our website?',
      Privacy_1_P2: 'This privacy policy has been compiled to better serve those who are concerned with how their "Personally identifiable information" (PII) is being used online. PI is information that can be used on its own or with other information to identify, contact, or locate a single person, or to identify an individual in context. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with our website.',
      Privacy_2_P1: 'When do we collect information?',
      Privacy_2_P2: 'When you apply to register as a user of this website, you must fill in your name, email address and other personal information so that we can provide online services.',
      Privacy_3_P1: 'How do we use your information?',
      Privacy_3_P2: 'We collect information from you when you register on our site and the weblog, include your machine IP, visit time and download content, will be collected whenever you place the data request.',
      Privacy_4_P1: 'Information deadline?',
      Privacy_4_P2: 'From the time of registration until you choose to exit or delete the system, or until the service of this system is terminated. If the service of this system is terminated, it will be deleted properly and will not be leaked.',
      Privacy_5_P1: 'How do we protect the information we receive?',
      Privacy_5_P2: 'We will only use this information to improve the service performance of this website and send notification letters about data products on this website.',
      Privacy_6_P1: 'How can you opt out, remove or modify information you have provided to us?',
      Privacy_6_P2: 'You can contact us to completely delete your personal information, or log in to this website and enter the personal information page to modify or delete it.',
      Privacy_7_P1: 'Third Party Disclosures',
      Privacy_7_P2: 'We will not sell, trade or otherwise transfer your personally identifiable information to other parties unless we further notify you and obtain your full consent. However, we may release personal information based on considerations of complying with the law, strengthening the privacy policy of this website, or protecting the rights and security of this website and other users. That is to say, we will not transfer your personal information against your will unless reasonably requested by public authorities (such as courts or government units).',
      Privacy_8_P1: 'Disclosure of Your Personal Information',
      Privacy_8_P2: 'Under certain circumstances, we may be required to disclose your personal information if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency). In other cases, we will provide notice before your personal information is transferred and becomes subject to a different Privacy Policy.',
      Privacy_disagree: 'If you have any questions about this privacy policy, you can contact us via email',
      S1_P: 'The first BATS station (TWGB) was established in 1994. Presently, the network comprises 36 permanent broadband seismic stations, each equipped with both broadband and strong-motion seismometers. This includes two remote installations in the South China Sea. To enhance environmental monitoring capabilities, some BATS stations are equipped with infrasound sensors and weather stations. Seismic waveform data collected after March 1996 is accessible through the BATS Data Center.',
      //people
      PI_name_01: 'Huang, Bor-Shouh',
      PI_name_02: 'Lee, Shiann-Jong',
      PI_name_03: 'Huang, Hsin-Hua',
      PI_name_04: 'Liang, Wen-Tzong',
      PI_name_05: 'Lin, Chin-Jen',
      PI_name_06: 'Ku, Chin-Shang',
      PI_position_01: 'Distinguished Research Fellow',
      PI_position_02: 'Research Fellow',
      PI_position_03: 'Associate Research Fellow',
      PI_position_04: 'Senior Research Scientist',
      PI_position_05: 'Associate Research Scientist',
      PI_position_06: 'Assistant Research Scientist',
      Staff_name_01: 'Lee, Wen-Hui',
      Staff_name_02: 'Tsai, Ching-Lin',
      Staff_name_03: 'Chou, Hung-Jun',
      Staff_name_04: 'Chi, Tsung-Chih',
      Staff_name_05: 'Lin, Chia-Hsi',
      Staff_name_06: 'Tsai, Tsung-Ta',
      Staff_name_07: 'Yang, Che-Lun',
      Staff_position_01: 'Research Assistants',
      Staff_position_02: 'Computer Room',
      Staff_position_03: 'Research Assistants',
      Staff_position_04: 'Postdoctoral Fellow',
      Staff_position_05: 'Research Assistants',
      Staff_position_06: 'Research Assistants',
      Staff_position_07: 'Research Assistants',
    }
  },
  zh: {
    message: {
      about: '關於',
      autobats: 'MT震源解',
      autobats_subtitle: '採用AutoBATS自動地震矩張量反演的震源機制解',
      aboutBATS: '關於BATS',
      aboutBATS_subtitle: '台灣寬頻地震觀測網(Broadband Array in Taiwan for Seismology)',
      all: '全部',
      azimuth: '方位角',
      about_BATS: '關於BATS',
      amplitude: '振幅',
      autoBATS_CMT: 'AutoBATS地震矩張量解',
      address: '地址',
      account: '帳號',
      agree: '同意',
      BATS_station: 'BATS測站',
      BATS: '台灣寬頻地震觀測網(BATS)',
      BATS_Waveforms: 'BATS 波形',
      BATS_features: 'BATS的貢獻',
      BATS_lowercase: '台灣寬頻地震觀測網(BATS)',
      BATS_lowercase_br: '台灣寬頻地震觀測網(BATS)',
      color: '顏色',
      cluster: '叢集',
      channel: '分量',
      constant: '常數',
      continuous_wd: '連續波形資料',
      continuous_wd_dir: '地震連續資料下載，單測站不得超過90天',
      create_account: '建立帳戶',
      citation: '引用出處',
      data_management: '資料管理',
      data_request: '資料索取',
      depth: "深度",
      data: '資料',
      data_subtitle: '專供學術研究的高品質波形紀錄',
      dataProducts: '資料產品',
      dataProducts_subtitle: '基於BATS資料的研究成果',
      data_quality: '資料品質',
      data_availability: '可用資料',
      data_source1:'資料來源: 中央氣象署',
      data_source2:'資料來源: 中央氣象署、美國地質調查所',
      download: '下載',
      data_visualization: '資料視覺化',
      disagree: '不同意',
      dataProducts_title_01: 'AutoBATS地震矩張量解 ',
      dataProducts_title_02: '台灣地殼模型',
      dataProducts_title_03: '即時地震矩張量監測系統',
      dataProducts_subtitle_01: '(震源機制解)',
      dataProducts_subtitle_02: '(基於接收函數的觀測)',
      dataProducts_subtitle_03: '',
      end_date: '結束日期',
      end_date_: '結束日期',
      event: '事件(UTC)',
      elevation: '高程',
      end_time: '結束時間(UTC)',
      end_time_: '結束時間',
      email: '電子信箱',
      forget_password: "忘記密碼",
      forget_password_p1: "請輸入您的電子郵件信箱，我們將會寄信至您的信箱讓您重製密碼",
      forget_password_2: "重新設定密碼",
      greater_BATS: '更大的BATS',
      grid_line: '經緯線',
      google_scholar: 'Google學術搜尋',
      group_photos: '團體照',
      home: '首頁',
      historic: '已關閉',
      history: '歷史沿革',
      highlights: '亮點介紹',
      help: '說明',
      help_subtitle: 'BATS網站的使用說明',
      instrument_info: '儀器資訊',
      download_instrument_resp: '下載儀器響應',
      instrumentation: '儀器配備',
      ies: '中央研究院地球科學研究所',
      instrument_response: '儀器響應資料',
      links: '連結',
      link: '連結',
      links_subtitle: '你或許還想多知道多一些',
      latitude: '緯度',
      longitude: '經度',
      location: '位置',
      label: '輸出檔名',
      login: '登入',
      logout: '登出',
      login_error: '請先登入',
      link_subtitle_01: '台灣地震與地球物理資料管理系統',
      link_subtitle_02: '台灣地震科學資料中心',
      link_subtitle_03: '台灣即時地震科學資訊系統',
      link_subtitle_04: '國家地震工程研究中心地震網',
      link_subtitle_05: 'P-Alert強地動觀測網',
      link_subtitle_06: '即時地震矩張量監測系統',
      link_subtitle_07: '中央研究院地球科學研究所資料管理中心',
      link_subtitle_08: '台灣活動斷層',
      link_subtitle_09: '台灣地質資料整合查詢服務',
      login_success: '登入成功',
      login_success_text: '系統將於一個小時後自動登出',
      login_success_text_2: '請登入帳號',
      login_failed: '登入失敗',
      login_expired: '連結已過期',
      login_expired_text: '請重新申請密碼重設',
      // login_errortext_check: '請檢查您的帳號和密碼。',
      // login_errortext_verified: '此帳號未註冊或未驗證',
      // login_errortext_wrong: '密碼錯誤',
      login_errortext_check: '請檢查您的帳號或密碼',
      login_errortext_verified: '請檢查您的帳號或密碼',
      login_errortext_wrong: '請檢查您的帳號或密碼',
      login_errortext_code: '驗證碼錯誤',
      login_forgot_success: '成功',
      login_forgot_success_text: '請至您的信箱收信以完成申請程序',
      login_forgot_failed: '失敗',
      login_forgot_failed_text: '信箱不存在',
      login_forgot_server_error: '伺服器錯誤',
      login_forgot_server_error_text: '伺服器錯誤，請稍後再嘗試',
      login_forgot_failed_other: '操作失敗',
      login_forgot_failed_other_text: '請求未能完成，請確認資訊並重試',
      login_aut_failed: '驗證失敗',
      login_reset_success: '成功',
      login_reset_success_text: '請以新密碼重新登入',
      login_reset_failed: '失敗',
      login_reset_failed_text: '設定失敗',
      login_check_failed_text: '請檢查密碼',
      login_reset_error: '請確保密碼欄位已填寫',
      login_register_success: '註冊成功',
      login_register_s_text: '請至 <strong>信箱</strong> 收取 <strong>驗證信</strong>',
      login_register_failed: '註冊失敗',
      login_register_f_text: '信箱或帳號已存在',
      login_register_error: '請確保電子郵件和密碼欄位都已填寫',
      login_register_server_error: '伺服器錯誤',
      login_register_server_error_text: '伺服器錯誤，請稍後再嘗試',
      login_register_input_failed: '無效輸入',
      login_register_input_failed_text: '請確認所有欄位後再嘗試',
      login_register_failed_other: '操作失敗',
      login_register_failed_other_text: '請求未能完成，請確認資訊並重試',
      login_token_expired_1: '連結已失效',
      login_token_expired_2: '請重新註冊',
      more: '更多',
      more_information: '更多資訊',
      map_lock: '鎖定地圖',
      min: '最小值',
      max: '最大值',
      ml: '芮氏規模',
      multi_station_wd: '多站波形資料',
      multi_station_wd_dir: '多站波形資料下載，索取時間不可超過1天(86400秒)',
      multi_event_wd: '多筆事件波形資料',
      multi_event_dir: '地震事件資料下載，一次最多100筆',
      member_data: '個人資料',
      more_result: '更多科學成果',
      more_data: '更多台灣的數據和資訊',
      name: '名稱',
      name_full: '姓名',
      affiliation: '單位',
      affiliation_note: '上限為 100 字元，僅允許中英文、數字、空白鍵以及 "," 和 "_"',
      affiliation_note_popup: '單位欄位錯誤',
      network: '測網',
      no_data: '沒有資料',
      no_data_text: '請選擇其他時間段',
      online: '未關閉',
      output: '輸出格式',
      our_team: '團隊成員',
      origin: '發震時間(UTC)',
      people: '人員',
      people_subtitle: '強大的科學及技術支援團隊',
      password: '密碼',
      password_new: '新密碼',
      password_check: '確認密碼',
      password_error: '密碼需包含英文大寫、小寫、數字及特殊符號，且長度至少需12碼',
      password_check_error: '與密碼不相符',
      position: '職位',
      PI: '計畫主持人',
      read_more: '更多',
      recorder: '記錄器',
      register: '註冊',
      required: '必填',
      station: '測站',
      station_subtitle: '同時配備寬頻及強地動地震儀',
      start_date: '開始日期',
      start_date_: '開始日期',
      setting: '設定',
      size: '大小',
      station_list: '測站列表',
      search: '搜尋',
      sensor: '感應器',
      start_time: '起始時間(UTC)',
      submit: '送出',
      significant_E: '重大地震資料',
      say_hello: "聯絡我們",
      second: '秒',
      sign_up: '會員註冊',
      staff: '工作人員',
      select_format: '選擇格式',
      select_network: '選擇測網',
      select_station: '選擇測站',
      select_location: '選擇位置',
      select_channel: '選擇分量',
      select_start_time: 'yyyy-MM-dd HH:mm:ss',
      select_start_time_YMD: 'yyyy-MM-dd',
      select_end_time: 'yyyy-MM-dd HH:mm:ss',
      select_end_time_YMD: 'yyyy-MM-dd',
      select_label: '輸入檔案名稱 (可選, 上限 30 字元)',
      travel_time_plot: '走時波形圖',
      time_windows: '時間段',
      to: '至',
      title_station: '搜尋測站',
      title_lat_min: '搜尋緯度最小值',
      title_lat_max: '搜尋緯度最大值',
      title_lat: '搜尋緯度',
      title_lon_min: '搜尋經度最小值',
      title_lon_max: '搜尋經度最大值',
      title_lon: '搜尋經度',
      title_start_min: '搜尋開始日期最小值',
      title_start_max: '搜尋開始日期最大值',
      title_start: '搜尋開始日期',
      title_end_min: '搜尋結束日期最小值',
      title_end_max: '搜尋結束日期最大值',
      title_end: '搜尋結束日期',
      DataSince: '資料起始時間 2022.01.01',
      title_event: '搜尋發震時間',
      title_ML_min: '搜尋芮氏規模最小值',
      title_ML_max: '搜尋芮氏規模最大值',
      title_depth_min: '搜尋深度最小值',
      title_depth_max: '搜尋深度最大值',
      apply_filter: '套用條件',
      url_hide: '隱藏URL',
      url_show: '顯示URL',
      waveform: '波形圖',
      wd_error_label_STET: '開始時間必須早於結束時間',
      wd_error_label_24H: '開始時間和結束時間不可超過24小時',
      wd_error_label_90D: '開始時間和結束時間不可超過90天',
      wd_error_label_starttimeNull: '請選擇開始時間',
      wd_error_label_endtimeNull: '請選擇結束時間',
      wd_error_label_station: '請至少選擇一個測站',
      wd_error_label_location: '請至少選擇一個位置',
      wd_error_label_channel: '請至少選擇一個分量',
      wd_error_label_timewindows: '請選擇時間段',
      wd_error_label_timeUTC: '請選擇時間(UTC)',
      wd_error_label_timeUTC_100: '不可超過100筆事件',
      wd_error_label_timeUTC_format: '無效的日期格式',
      wd_error_label_timeUTC_data: '無效的日期',
      wd_error_label_network: '請選擇一個測網',
      wd_error_label_output: '請選擇一個格式',
      wd_error_filenameformat: '無效字元',
      web_data_services: '網路資料服務',
      year: '年份',
      //phase
      About_1_P1: '台灣寬頻地震觀測網',
      About_1_P2: '1992年中，中研院地球所和國內外數個學術機構合作，共同擘劃新一代的寬頻地震觀測網，這個觀測網隨後被命名為台灣寬頻地震觀測網(Broadband Array in Taiwan for Seismology, BATS)。BATS從1996年成網後，即開始提供高品質的寬頻波形資料與可靠的區域震源機制解。',
      About_1_P3: '一開始設計在全台及鄰近離島部署15部永久性地震測站，涵蓋的範圍大約有350公里x 400公里區域，並於1994年在台東地區建設完成第一個BATS測站。',
      About_1_P4: '目前(2025.01)BATS的永久性測站總數已達36座，其中也包括南中國海區域的兩個島礁測站。除少數低地震活動度的位置，多數測站均同時配備寬頻及強地動地震儀。',
      About_2_P1: '儀器安裝',
      About_2_P2: 'BATS的觀測儀器設備能滿足不同研究需求',
      About_2_P3: '幾乎所有BATS測站均同時安裝寬頻與強地動地震儀，並搭配24/26位元紀錄器；部分測站也增設次聲波及天氣參數的監測儀器。',
      About_2_P4: '早期受限於儲存空間，高取樣率(每秒100點)的地震波形採觸發型紀錄方式，因此沒有連續紀錄。而自2002年更新記錄器(Q330)之後，所有取樣率的波形資料均以連續紀錄的方式儲存下來。',
      About_2_P5: '目前所有測站都透過各式的通訊系統連上網路，即時波形資料可以很容易地即刻擷取。此外BATS也在不斷演進，配合研究學者陸續引進新的觀測儀器，以提供學術界更完備的資料。',
      About_3_P1: '資料管理',
      About_3_P2: '以更可靠的資料促進地震學研究',
      About_3_P3: '資料中心運用各式的軟體平台收集BATS的波形紀錄，隨後由中研院地球所技術團隊進行初步的資料品質控管。',
      About_3_P4: 'BATS所收集的資料都會在BATS的官網上開放給各界使用。',
      About_3_P5: '中研院地球所在2001年設置資料管理中心(IESDMC)，負責例行性的觀測網運作業務，包括資料處理與典藏、品質控管，以及資料流通等事項。此外也已經開發新的技術(AutoBATS)，將震源反演的工作完全自動化，可近即時取得可靠的震源機制解。',
      AutoBATS_1: 'AutoBATS',
      AutoBATS_2: '自動化震源反演系統：AutoBATS',
      AutoBATS_3: 'AutoBATS自動化震源反演系統由氣象署地震測報中心的地震速報資訊觸發，系統在接收到速報資訊的第一時間即刻啟動解算系統，先從BATS的寬頻地震波形裡自動挑出高品質的波形，搭配自動化參數掃描以反演地震的矩張量解來求得震源機制，這些地震矩張量解都會收藏在線上資料庫供外界進一步參考。',
      Footer_1_P1: '115台北市南港區',
      Footer_1_P2: '研究院路二段128號中央研究院',
      Footer_1_P3: '環境變遷大樓A棟7樓7005',
      Footer_4_P1: '需要AutoBATS震源機制解？',
      Footer_4_P2: '訂閱AutoBATS可以取得經專人確認後的地震矩張量解email通知。',
      Footer_4_P3: '訂閱AutoBATS報告通知',
      Footer_policy: '使用者條款、資訊安全與隱私權政策',
      Home_1_P1: '台灣地區的骨幹型地震觀測網',
      Home_1_P2: 'BATS配備經典的地震儀及次聲波感測器，由中研院地球所於1996年開始正式運作。',
      Home_1_P3: '我們提供高品質的波形資料和地震矩張量震源機制解，並致力於震源物理和地震地體構造研究。',
      Home_2_P1: '我們提供地震波形資料、MT震源機制和儀器系統服務',
      Home_2_P2: '網路資料服務、線上波形瀏覽、地震走時波形圖展示',
      Home_2_P3: '根據BATS波形反演所得的地震矩張量解能反映地震斷層的破裂滑移形態',
      Home_2_P4: '透過Google學術搜尋以瞭解BATS自1996年運作之後的學術貢獻',
      Home_3_P1: '現代的BATS網路資料服務',
      Home_3_P2: 'BATS資料中心秉持開放資料政策並採用新技術來開發高效能的網路服務，使得資料的索取和視覺化更加便捷',
      Home_3_P3: '資料公開',
      Home_3_P4: '互動式波形瀏覽',
      Home_3_P5: 'Google學術搜尋',
      Privacy_0: '隱私權政策',
      Privacy_1_P1: '我們從網站收集哪些個人資訊?',
      Privacy_1_P2: '非常歡迎您光臨「台灣寬頻地震觀測網(BATS)」（以下簡稱本網站），為了讓您能夠安心的使用本網站的各項服務與資訊，特此向您說明本網站的隱私權保護政策，以保障您的權益。請您詳閱下列內容：',
      Privacy_2_P1: '我們何時會收集個人資訊?',
      Privacy_2_P2: '當您申請註冊成為本網站使用者時，您必須填入姓名、電子郵件信箱等個人資訊，以便我們提供線上的服務。',
      Privacy_3_P1: '我們如何使用您的資訊?',
      Privacy_3_P2: '當您登入本網站之後，一旦索取任何的資料，您的機器IP位址、訪問時間、下載資料內容等資訊將會被收集起來。',
      Privacy_4_P1: '您的個人資訊儲於本系統的存續期限?',
      Privacy_4_P2: '自註冊申請時至您選擇退出本系統或刪除，或至本系統服務終止為止，如本系統服務終止，亦將妥善銷毀而不使其外洩。',
      Privacy_5_P1: '我們如何保護所接收的資訊?',
      Privacy_5_P2: '我們只會運用這些資訊在改善本網站的服務效能及寄送本網站有關資料產品的通知信。',
      Privacy_6_P1: '您要如何退出、刪除或修改您已經提供給我們的資訊?',
      Privacy_6_P2: '您可連絡我們完全刪除您的個人資訊，或者登入本網站後進入個人資訊網頁進行修改或刪除。',
      Privacy_7_P1: '我們會向第三方揭露嗎?',
      Privacy_7_P2: '我們不會販售、交易或以其他方式轉移您的個人可辨識資訊給其他單位，除非我們有進一步通知並獲得您的完全同意。但是在基於遵守法律、強化本網站隱私政策或保護本網站及其他使用者的權益及安全的考量下，我們有可能釋出個人資訊。也就是說，除非公部門(例如法院或政府單位)提出合理要求，否則我們不會在違反個人意願下轉移您的個人資訊。',
      Privacy_8_P1: '您的個人資訊的保留',
      Privacy_8_P2: '我們只會在符合這個隱私權政策下的時間內，保留您的個人資訊，並且合法、合理地使用這些資訊來解決問題，同時強化我們的政策。 自註冊申請時至您選擇退出本系統或刪除，或至本系統服務終止為止，如本系統服務終止，亦將妥善銷毀而不使其外洩。',
      Privacy_disagree: '如果您有任何關於這個隱私權政策的疑問，可以透過email與我們聯繫',
      S1_P: '第一部台灣寬頻地震觀測網(BATS)的測站設置在台東(TWGB)，並於1994年落成啟用，至今共有36部永久的寬頻測站部署在台灣地區，包括幾個離島及兩部位於南海的寬頻測站。幾乎每個測站同時配備有寬頻地震儀和強震儀，可收錄區域及全球的地震波形。此外，為加強環境監測，部分測站加裝次聲波感測器及氣象站。1996年3月後所記錄的地震波形資料完全對外開放，歡迎對這些資料有興趣的使用者，善用本網站的資料下載功能進行索取。',
      //people
      PI_name_01: '黃柏壽',
      PI_name_02: '李憲忠',
      PI_name_03: '黃信樺',
      PI_name_04: '梁文宗',
      PI_name_05: '林欽仁',
      PI_name_06: '古進上',
      PI_position_01: '特聘研究員',
      PI_position_02: '研究員',
      PI_position_03: '副研究員',
      PI_position_04: '研究技師',
      PI_position_05: '研究副技師',
      PI_position_06: '研究助技師',
      Staff_name_01: '李文蕙',
      Staff_name_02: '蔡青霖',
      Staff_name_03: '周宏潤',
      Staff_name_04: '紀宗志',
      Staff_name_05: '林家熙',
      Staff_name_06: '蔡宗達',
      Staff_name_07: '楊哲倫',
      Staff_position_01: '研究助理',
      Staff_position_02: '電腦資訊管理人員',
      Staff_position_03: '研究助理',
      Staff_position_04: '博士後研究',
      Staff_position_05: '研究助理',
      Staff_position_06: '研究助理',
      Staff_position_07: '研究助理',
    }
  }
};

const i18n = createI18n({
  legacy: false, // for Vue 3
  locale: 'en', // 設置預設語言
  fallbackLocale: 'en', // 如果當前語言找不到對應的內容，將回退到該語言
  messages,
})

export default i18n
